import { InMemoryCache } from '@apollo/client/cache/index.js';
import { initApolloClient } from './initApolloClient.js';
import { SchemaLinkApolloClientFactory } from './SchemaLinkApolloClientFactory.js';
/**
 * Initializes an apollo client using the SchemaLinkApolloClientFactory
 * @param initialState - default cache
 * @param schema - executable schema
 * @param context - request context
 */
export function initSchemaLinkApolloClient(initialState, schema, context) {
    return initApolloClient(initialState, new SchemaLinkApolloClientFactory(initialState, schema, context), {
        cache: new InMemoryCache()
    });
}
//# sourceMappingURL=initSchemaLinkApolloClient.js.map